import { registerBlockType } from '@wordpress/blocks';
import metadata from './block.json';
import Edit from './Edit';
import Save from './save';
import './style.scss';
import './editor.scss';

registerBlockType(metadata.name, {
  edit: Edit,
  save: Save,
  icon: {
    foreground: '#0061FE',
    src: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <circle cx="9" cy="12" r="5" fill="currentColor" opacity="0.35" />
        <circle cx="15" cy="12" r="5" stroke="currentColor" strokeWidth="1.5" fill="none" />
      </svg>
    ),
  },
});
